export default "__VITE_ASSET__C2Mji1zO__"